export interface Service {
  id: string;
  title: string;
  description: string;
  shortDescription: string;
  icon: string;
  image: string;
  features: string[];
}

export const services: Service[] = [
  {
    id: 'excavation',
    title: 'EXCAVATION',
    description: 'Our professional excavation services provide precision and safety for residential and commercial projects throughout the Truckee-Tahoe region. With decades of experience and state-of-the-art equipment, we handle everything from small residential foundations to large commercial developments.',
    shortDescription: 'Professional excavation services for residential and commercial projects with precision and safety.',
    icon: '/assets/icons/Excavation.svg',
    image: '/assets/images/services/Excavation.png',
    features: [
      'Foundation excavation and preparation',
      'Utility trenching and installation',
      'Basement and crawl space excavation',
      'Septic system installation',
      'Drainage system installation',
      'Emergency excavation services'
    ]
  },
  {
    id: 'mastication',
    title: 'MASTICATION',
    description: 'Our mastication services reduce wildfire fuel and clear overgrown ground without burn piles or haul-off. Purpose-built masticator heads grind brush, small trees, and slash in place, leaving a mulch layer that holds the soil and breaks down naturally. It is a fast, low-impact way to open up a property, build defensible space around structures, and prepare ground for construction throughout the Truckee-Tahoe region.',
    shortDescription: 'Wildfire fuel reduction and land clearing that grinds brush and slash into mulch on site.',
    icon: '/assets/icons/Mastication.svg',
    image: '/assets/images/services/Mastication.png',
    features: [
      'Defensible space around homes and structures',
      'Wildfire fuel reduction and brush clearing',
      'Lot, road, and right-of-way clearing',
      'Fuel break creation and maintenance',
      'Site preparation ahead of grading and construction',
      'On-site mulching with no burn piles or debris hauling'
    ]
  },
  {
    id: 'concrete-masonry',
    title: 'CONCRETE MASONRY',
    description: 'From structural foundations to detailed flatwork, our concrete masonry team delivers high-quality results. We specialize in driveways, curbs, sidewalks, slabs, and other structural concrete applications, ensuring durability and aesthetics meet your project requirements.',
    shortDescription: 'High-quality concrete masonry services from structural foundations to detailed flatwork.',
    icon: '/assets/icons/Concrete-masonry.svg',
    image: '/assets/images/services/Concrete.png',
    features: [
      'Structural foundations and footings',
      'Slab-on-grade installation',
      'Sidewalks, curbs, and gutters',
      'Retaining wall construction',
      'Reinforced concrete work (rebar/mesh integration)'
    ]
  },
  {
    id: 'fabrication',
    title: 'FABRICATION',
    description: 'Our in-house fabrication capabilities include building custom railings and specialty steel structures. We combine form and function to deliver unique solutions tailored to each site\'s needs.',
    shortDescription: 'Custom fabrication services for railings and specialty steel structures.',
    icon: '/assets/icons/Fabrication.svg',
    image: '/assets/images/services/Fabrication.png',
    features: [
      'Custom steel fabrication',
      'Steel railing design and build',
      'Architectural and structural steel components',
      'On-site welding and installation',
      'Project-specific metalwork solutions',
      'Coordination with design and engineering teams'
    ]
  },
  {
    id: 'commercial-snow-removal',
    title: 'COMMERCIAL SNOW REMOVAL',
    description: 'Our commercial snow removal services keep your business accessible and safe during winter months in the Truckee-Tahoe region. We understand that snow can significantly impact your operations, which is why we offer reliable and efficient snow removal solutions. With our fleet of specialized equipment and experienced operators, we ensure that your parking lots, driveways, and walkways are cleared quickly and thoroughly, minimizing disruption to your business.',
    shortDescription: 'Reliable commercial snow removal services to keep your business accessible during winter months.',
    icon: '/assets/icons/Snow-Removal.svg',
    image: '/assets/images/services/Snow removal.png',
    features: [
      'Snow plowing for lots and roads',
      'Sidewalk and entryway shoveling',
      'Snow blowing for narrow or hard-to-reach areas',
      'Ice management and de-icing',
      'Seasonal service contracts'
    ]
  }
];

export const getServiceById = (id: string): Service | undefined => {
  return services.find(service => service.id === id);
}; 